import { render } from "./ownAttendeeSelect.html?vue&type=template&id=6a4d88b6&ts=true&external"
import script from "./ownAttendeeSelect.ts?vue&type=script&lang=ts&external"
export * from "./ownAttendeeSelect.ts?vue&type=script&lang=ts&external"

import "./ownAttendeeSelect.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__